import "react-awesome-button/dist/styles.css";
import { Fade } from "react-awesome-reveal";
import { PiStudentFill } from "react-icons/pi";
import { FaTools, FaArrowUp } from "react-icons/fa";
import { SiRetool } from "react-icons/si";
import { useState, useEffect } from "react";

import { skillCategories, knowledgeSets } from "../data/skillsData";

export default function About() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.querySelector('.about-container')?.scrollTop || 0;
      setShowScrollTop(scrollTop > 300);
    };

    const container = document.querySelector('.about-container');
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToTop = () => {
    const container = document.querySelector('.about-container');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="about-container flex flex-col bg-gradient-to-br from-dark-bg-950 via-dark-bg-900 to-dark-bg-950 dark:bg-hero-pattern px-4 py-6 h-screen overflow-x-hidden overflow-y-auto transition-all duration-300 scroll-smooth">
      <div className="flex justify-center items-start w-full pt-8 pb-32">
        <div className="relative flex flex-col justify-start items-start gap-12 w-full max-w-[1000px] min-h-[calc(100vh-8rem)]">

          <Fade delay={1500} triggerOnce={true} className="w-full">
            <h1 className="flex justify-start items-center gap-4 font-bold text-white text-[25px] md:text-[30px] uppercase font-inter">
              <FaTools size={24} className="text-accent-400" />
              <span className="text-white">
                Skill Sets
              </span>
            </h1>
            
            {/* Categorized Skills */}
            <div className="flex flex-col gap-10 w-full">
              {skillCategories.map((category, categoryKey) => (
                <Fade delay={categoryKey * 200 + 1600} triggerOnce={true} key={categoryKey}>
                  <div className="flex flex-col gap-5 w-full">
                    <h2 className="text-xl font-bold text-gray-100 font-inter text-left border-b border-accent-400/30 pb-3">
                      {category.name}
                    </h2>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 w-full mb-4">
                      {category.skills.map((skill, skillKey) => {
                        const IconComponent = skill.icon;
                        return (
                          <Fade delay={skillKey * 50} triggerOnce={true} key={skillKey}>
                            <div
                              className="flex items-center justify-center gap-1 px-3 py-2 font-medium uppercase rounded-lg md:text-[.65em] text-[.6em] cursor-pointer duration-300 transition-all text-center hover:scale-105 whitespace-nowrap overflow-hidden shadow-sm"
                              style={{ 
                                backgroundColor: skill.color,
                                color: '#FFFFFF'
                              }}
                            >
                              {IconComponent && <IconComponent size={16} />}
                              <span className="truncate">{skill.name}</span>
                            </div>
                          </Fade>
                        );
                      })}
                    </div>
                  </div>
                </Fade>
              ))}
            </div>
          </Fade>
          <Fade delay={1800} triggerOnce={true} className="w-full">
            <h1 className="flex justify-start items-center gap-3 font-bold text-white text-[25px] md:text-[30px] uppercase font-inter mb-6">
              <SiRetool size={23} className="text-purple-accent-400" />
              <span className="bg-gradient-to-r from-purple-accent-400 via-accent-400 to-purple-accent-500 bg-clip-text text-transparent">
                KNOWLEDGE
              </span>
            </h1>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full mb-8">
              {knowledgeSets.map((item, key) => (
                <div
                  key={key}
                  className={`w-full px-4 py-3 flex items-center justify-center border border-white/20 text-gray-200
                   bg-dark-bg-800/50 font-medium backdrop-blur-sm shadow-card-dark uppercase rounded-xl
                    md:text-[.75em] text-[.7em] cursor-pointer hover:bg-gradient-to-r hover:from-purple-accent-600/20 hover:to-accent-600/20 hover:text-white duration-300 transition-all text-center hover:scale-105`}
                >
                  {item}
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </div>
      
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-20 right-6 z-50 p-3 bg-gradient-to-r from-accent-600 to-purple-accent-600 hover:from-accent-500 hover:to-purple-accent-500 text-white rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 hover:shadow-glow-purple"
          aria-label="Scroll to top"
        >
          <FaArrowUp size={16} />
        </button>
      )}
    </div>
  );
}
